var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f0efef;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #a31e21;\n      }\n\n      .cls-3, .cls-5 {\n        fill: #afafae;\n      }\n\n      .cls-4, .cls-6 {\n        fill: #7f7f7f;\n      }\n\n      .cls-5, .cls-6 {\n        fill-rule: evenodd;\n      }\n\n      .cls-7 {\n        fill: #0b0b0b;\n      }\n\n      .cls-8 {\n        fill: #ee2157;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 522.31,
    y: 526.94,
    width: 8.89,
    height: 204.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 557.84,
    y: 499.15,
    width: 8.89,
    height: 232.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 593.37,
    y: 499.15,
    width: 8.89,
    height: 232.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 628.91,
    y: 499.15,
    width: 8.89,
    height: 232.18
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 522.31,
    y: 721.43,
    width: 115.49,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 522.31,
    y: 693.65,
    width: 115.49,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 522.31,
    y: 665.86,
    width: 115.49,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 522.31,
    y: 638.08,
    width: 115.49,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 522.31,
    y: 610.29,
    width: 115.49,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 522.31,
    y: 582.51,
    width: 115.49,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 522.31,
    y: 554.72,
    width: 115.49,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 557.84,
    y: 526.94,
    width: 79.96,
    height: 3.83
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 557.84,
    y: 582.51,
    width: 79.96,
    height: 148.83
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 332.21,
    y: 499.15,
    width: 59.42,
    height: 232.18
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 386.23,
    y: 471.37,
    width: 5.4,
    height: 259.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 409.78,
    y: 471.37,
    width: 5.4,
    height: 259.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 433.33,
    y: 471.37,
    width: 5.4,
    height: 259.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 456.88,
    y: 499.15,
    width: 5.4,
    height: 232.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 415.18,
    y: 471.37,
    width: 5.89,
    height: 259.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 438.73,
    y: 471.37,
    width: 5.89,
    height: 259.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 462.28,
    y: 499.15,
    width: 5.89,
    height: 232.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 415.18,
    y: 582.51,
    width: 29.44,
    height: 148.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 444.62,
    y: 687.91,
    width: 17.66,
    height: 5.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 444.62,
    y: 715.69,
    width: 17.66,
    height: 15.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 444.62,
    y: 660.12,
    width: 17.66,
    height: 5.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 444.62,
    y: 632.34,
    width: 17.66,
    height: 5.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 391.63,
    y: 471.37,
    width: 5.89,
    height: 259.97
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 391.63,
    y: 721.43,
    width: 76.54,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 391.63,
    y: 693.65,
    width: 76.54,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 391.63,
    y: 665.86,
    width: 76.54,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 391.63,
    y: 638.08,
    width: 76.54,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 391.63,
    y: 610.29,
    width: 76.54,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 391.63,
    y: 582.51,
    width: 76.54,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 391.63,
    y: 554.72,
    width: 76.54,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 391.63,
    y: 526.94,
    width: 76.54,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 391.63,
    y: 499.15,
    width: 52.99,
    height: 3.83
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 391.63,
    y: 499.15,
    width: 29.44,
    height: 232.18
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 426.27,
    y: 641.9,
    width: 7.26,
    height: 18.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 426.27,
    y: 669.69,
    width: 7.26,
    height: 18.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 426.27,
    y: 697.47,
    width: 7.26,
    height: 18.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 426.27,
    y: 614.12,
    width: 7.26,
    height: 18.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 426.27,
    y: 586.33,
    width: 7.26,
    height: 18.22
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 429.9,
    y: 641.9,
    width: 3.63,
    height: 18.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 429.9,
    y: 669.69,
    width: 3.63,
    height: 18.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 429.9,
    y: 697.47,
    width: 3.63,
    height: 18.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 429.9,
    y: 614.12,
    width: 3.63,
    height: 18.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 429.9,
    y: 586.33,
    width: 3.63,
    height: 18.22
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 208.15,
    y: 389.07,
    width: 71.07,
    height: 343.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 279.21,
    y: 389.07,
    width: 47.1,
    height: 343.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 163.72,
    y: 389.07,
    width: 8.89,
    height: 343.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 199.25,
    y: 389.07,
    width: 8.89,
    height: 343.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 234.79,
    y: 389.07,
    width: 8.89,
    height: 343.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 270.32,
    y: 389.07,
    width: 8.89,
    height: 343.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 172.61,
    y: 389.07,
    width: 5.4,
    height: 343.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 208.15,
    y: 389.07,
    width: 5.4,
    height: 343.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 243.68,
    y: 389.07,
    width: 5.4,
    height: 343.32
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 163.72,
    y: 722.49,
    width: 115.49,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 163.72,
    y: 694.7,
    width: 115.49,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 163.72,
    y: 666.92,
    width: 115.49,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 163.72,
    y: 639.13,
    width: 115.49,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 163.72,
    y: 611.35,
    width: 115.49,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 163.72,
    y: 583.57,
    width: 115.49,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 163.72,
    y: 555.78,
    width: 115.49,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 163.72,
    y: 528,
    width: 115.49,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 163.72,
    y: 500.21,
    width: 115.49,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 163.72,
    y: 472.43,
    width: 115.49,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 163.72,
    y: 444.64,
    width: 115.49,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 163.72,
    y: 416.86,
    width: 115.49,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 163.72,
    y: 389.07,
    width: 115.49,
    height: 3.83
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 208.15,
    y: 333.5,
    width: 71.07,
    height: 55.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 162.2,
    y: 361.29,
    width: 10.41,
    height: 27.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 172.61,
    y: 361.29,
    width: 6.92,
    height: 27.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 197.73,
    y: 361.29,
    width: 10.41,
    height: 27.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 208.15,
    y: 361.29,
    width: 6.92,
    height: 27.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 233.27,
    y: 361.29,
    width: 10.41,
    height: 27.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 243.68,
    y: 361.29,
    width: 6.92,
    height: 27.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 268.8,
    y: 361.29,
    width: 10.41,
    height: 27.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 349.86,
    y: 389.07,
    width: 5.89,
    height: 343.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 326.31,
    y: 389.07,
    width: 5.89,
    height: 343.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 302.76,
    y: 389.07,
    width: 5.89,
    height: 343.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 279.21,
    y: 389.07,
    width: 5.89,
    height: 343.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 344.46,
    y: 389.07,
    width: 5.4,
    height: 343.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 320.91,
    y: 389.07,
    width: 5.4,
    height: 343.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 297.36,
    y: 389.07,
    width: 5.4,
    height: 343.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 279.21,
    y: 333.5,
    width: 47.1,
    height: 55.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 279.21,
    y: 361.29,
    width: 6.92,
    height: 27.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 296.33,
    y: 361.29,
    width: 6.43,
    height: 27.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 302.76,
    y: 361.29,
    width: 6.92,
    height: 27.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 319.88,
    y: 361.29,
    width: 6.43,
    height: 27.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 326.31,
    y: 361.29,
    width: 6.92,
    height: 27.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 343.43,
    y: 361.29,
    width: 6.43,
    height: 27.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 349.86,
    y: 361.29,
    width: 6.92,
    height: 27.78
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 279.21,
    y: 722.49,
    width: 76.54,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 279.21,
    y: 694.7,
    width: 76.54,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 279.21,
    y: 666.92,
    width: 76.54,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 279.21,
    y: 639.13,
    width: 76.54,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 279.21,
    y: 611.35,
    width: 76.54,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 279.21,
    y: 583.57,
    width: 76.54,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 279.21,
    y: 555.78,
    width: 76.54,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 279.21,
    y: 528,
    width: 76.54,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 279.21,
    y: 500.21,
    width: 76.54,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 279.21,
    y: 472.43,
    width: 76.54,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 279.21,
    y: 444.64,
    width: 76.54,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 279.21,
    y: 416.86,
    width: 76.54,
    height: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 279.21,
    y: 389.07,
    width: 76.54,
    height: 3.83
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 210.85,
    y: 716.75,
    width: 23.94,
    height: 5.74
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 163.26,
    y: 362.58,
    width: 8.3,
    height: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 163.26,
    y: 368.56,
    width: 8.3,
    height: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 163.26,
    y: 374.53,
    width: 8.3,
    height: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 163.26,
    y: 380.51,
    width: 8.3,
    height: 1.29
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 175.32,
    y: 716.75,
    width: 23.94,
    height: 5.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 246.38,
    y: 716.75,
    width: 23.94,
    height: 5.74
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 198.79,
    y: 362.58,
    width: 8.3,
    height: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 198.79,
    y: 368.56,
    width: 8.3,
    height: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 198.79,
    y: 374.53,
    width: 8.3,
    height: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 198.79,
    y: 380.51,
    width: 8.3,
    height: 1.29
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 234.32,
    y: 362.58,
    width: 8.3,
    height: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 234.32,
    y: 368.56,
    width: 8.3,
    height: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 234.32,
    y: 374.53,
    width: 8.3,
    height: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 234.32,
    y: 380.51,
    width: 8.3,
    height: 1.29
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 269.86,
    y: 362.58,
    width: 8.3,
    height: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 269.86,
    y: 368.56,
    width: 8.3,
    height: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 269.86,
    y: 374.53,
    width: 8.3,
    height: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 269.86,
    y: 380.51,
    width: 8.3,
    height: 1.29
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 210.85,
    y: 688.96,
    width: 23.94,
    height: 5.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 175.32,
    y: 688.96,
    width: 23.94,
    height: 5.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 246.38,
    y: 688.96,
    width: 23.94,
    height: 5.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 210.85,
    y: 661.18,
    width: 23.94,
    height: 5.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 175.32,
    y: 661.18,
    width: 23.94,
    height: 5.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 246.38,
    y: 661.18,
    width: 23.94,
    height: 5.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 210.85,
    y: 633.39,
    width: 23.94,
    height: 5.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 175.32,
    y: 633.39,
    width: 23.94,
    height: 5.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 246.38,
    y: 633.39,
    width: 23.94,
    height: 5.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 210.85,
    y: 605.61,
    width: 23.94,
    height: 5.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 175.32,
    y: 605.61,
    width: 23.94,
    height: 5.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 246.38,
    y: 605.61,
    width: 23.94,
    height: 5.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 246.38,
    y: 577.82,
    width: 23.94,
    height: 5.74
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 297.26,
    y: 362.58,
    width: 4.58,
    height: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 297.26,
    y: 368.56,
    width: 4.58,
    height: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 297.26,
    y: 374.53,
    width: 4.58,
    height: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 297.26,
    y: 380.51,
    width: 4.58,
    height: 1.29
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 320.81,
    y: 362.58,
    width: 4.58,
    height: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 320.81,
    y: 368.56,
    width: 4.58,
    height: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 320.81,
    y: 374.53,
    width: 4.58,
    height: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 320.81,
    y: 380.51,
    width: 4.58,
    height: 1.29
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 344.36,
    y: 362.58,
    width: 4.58,
    height: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 344.36,
    y: 368.56,
    width: 4.58,
    height: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 344.36,
    y: 374.53,
    width: 4.58,
    height: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 344.36,
    y: 380.51,
    width: 4.58,
    height: 1.29
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 279.21,
    y: 583.57,
    width: 29.44,
    height: 59.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 210.85,
    y: 726.32,
    width: 23.94,
    height: 6.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 175.32,
    y: 726.32,
    width: 23.94,
    height: 6.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 246.38,
    y: 726.32,
    width: 23.94,
    height: 6.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 279.21,
    y: 639.13,
    width: 76.54,
    height: 93.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 313.85,
    y: 670.75,
    width: 7.26,
    height: 18.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 313.85,
    y: 642.96,
    width: 7.26,
    height: 18.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 313.85,
    y: 698.53,
    width: 7.26,
    height: 18.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 317.49,
    y: 642.96,
    width: 3.63,
    height: 18.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 317.49,
    y: 670.75,
    width: 3.63,
    height: 18.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 317.49,
    y: 698.53,
    width: 3.63,
    height: 18.22
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m481.84,283.56l3.91-51.67,9.47,20.9,1.95,28.97c.07,1,.9,1.78,1.9,1.78h11.31c.55,0,1.08-.24,1.44-.67s.52-.99.43-1.54l-20.23-132.86s-.02-.09-.04-.15c-.02-.06-.02-.13-.05-.2-.02-.06-.06-.13-.08-.18-.02-.05-.04-.1-.07-.14-.04-.07-.09-.13-.13-.2-.02-.03-.05-.07-.07-.1-.05-.06-.12-.13-.19-.18-.02-.02-.05-.05-.08-.07-.08-.06-.16-.11-.24-.16-.02,0-.04-.02-.06-.04-.22-.11-.46-.18-.72-.21h-.37s-.1.02-.15.03c-.07.02-.15.03-.22.05-.03,0-.06.02-.09.04-.09.03-.17.06-.24.11-.02.02-.05.03-.07.05-.08.05-.16.1-.22.16-.03.02-.05.06-.08.08-.05.06-.12.11-.17.17-.03.04-.05.08-.08.12-.04.06-.08.12-.12.18-.02.05-.04.09-.06.15-.02.06-.05.13-.08.19-.02.06-.02.1-.04.16-.02.07-.03.14-.04.21,0,.02,0,.03,0,.05l-10.22,134.93h3.82v.02Zm19-3.83l-1.14-17.03,7.71,17.03h-6.56Zm5.56-11.46l-7.44-16.42-1.72-25.61h2.75l6.4,42.03h0Zm-6.98-45.86h-2.43l-1.92-28.55,4.35,28.55Zm-4.93,19.54l-7.11-15.71h6.06l1.06,15.71Zm-4.46-66.45l3.16,46.91h-6.71l3.55-46.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m492.04,148.64c-.06-.97-.84-1.74-1.81-1.78-.98-.06-1.82.64-1.97,1.6l-21.71,132.86c-.09.55.06,1.12.43,1.55.36.43.89.68,1.45.68h30.64c.53,0,1.03-.22,1.39-.61.36-.39.54-.91.51-1.44l-8.93-132.86Zm4.24,120.03l-15.75-42.44h12.9l2.86,42.44Zm-6.93-103.25l3.83,56.98h-13.14l9.31-56.98h0Zm-10.84,66.31l17.81,48h-25.65l7.84-48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m512.27,732.39v-448.84h-34.45v448.84h3.81v-29.6l24.44,26.92h-7v2.68h13.21Zm-13.21-36.43h9.4v-26.91l-26.17,28.82,26.17,28.82v-26.92h-9.4v-3.81Zm0-67.52h9.4v-26.91l-26.17,28.82,26.17,28.82v-26.92h-9.4v-3.81Zm0-67.51h9.4v-26.91l-26.17,28.82,26.17,28.82v-26.92h-9.4v-3.81Zm0-67.51h9.4v-26.91l-26.17,28.82,26.17,28.82v-26.92h-9.4v-3.81Zm0-67.51h9.4v-26.91l-26.17,28.82,26.17,28.82v-26.92h-9.4v-3.81Zm0-67.52h9.4v-26.91l-26.17,28.82,26.17,28.82v-26.92h-9.4v-3.81Zm9.4-71.02h-26.84v4.68l26.84,29.56v-26.92h-9.4v-3.81h9.4v-3.51Zm-2.4,37.27l-24.44-26.92v57.65l24.44-26.92h-7v-3.81h7Zm0,67.51l-24.44-26.92v57.65l24.44-26.92h-7v-3.81h7Zm0,67.51l-24.44-26.92v57.65l24.44-26.92h-7v-3.81h7Zm0,67.51l-24.44-26.92v57.65l24.44-26.92h-7v-3.81h7Zm0,67.52l-24.44-26.92v57.65l24.44-26.92h-7v-3.81h7Zm0,67.51l-24.44-26.92v57.65l24.44-26.92h-7v-3.81h7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m500.97,732.39v-450.41h-34.45v450.41h34.45Zm-28.26-32.63l24.44,26.92v-26.92h-24.44Zm0-3.8h24.44v-26.92l-24.44,26.92Zm0-63.71l24.44,26.92v-26.92h-24.44Zm0-3.81h24.44v-26.92l-24.44,26.92Zm0-63.7l24.44,26.92v-26.92h-24.44Zm0-3.81h24.44v-26.92l-24.44,26.92Zm0-63.7l24.44,26.92v-26.92h-24.44Zm0-3.81h24.44v-26.92l-24.44,26.92Zm0-63.71l24.44,26.92v-26.92h-24.44Zm0-3.8h24.44v-26.92l-24.44,26.92Zm0-63.71l24.44,26.92v-26.92h-24.44Zm0-3.81h24.44v-26.92l-24.44,26.92Zm0-63.7l24.44,26.92v-26.92h-24.44Zm24.45-7.32h-26.84v3.51h26.84v-3.51Zm-2.4,37.27l-24.44-26.92v26.92h24.44Zm0,3.8h-24.44v26.92l24.44-26.92Zm0,63.71l-24.44-26.92v26.92h24.44Zm0,3.81h-24.44v26.92l24.44-26.92Zm0,63.7l-24.44-26.92v26.92h24.44Zm0,3.81h-24.44v26.92l24.44-26.92Zm0,63.7l-24.44-26.92v26.92h24.44Zm0,3.81h-24.44v26.92l24.44-26.92Zm0,63.71l-24.44-26.92v26.92h24.44Zm0,3.81h-24.44v26.92l24.44-26.92Zm0,63.7l-24.44-26.92v26.92h24.44Zm0,3.81h-24.44v26.92l24.44-26.92Zm0,63.7l-24.44-26.92v26.92h24.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m508.73,324.63h65.58v-37.27h-65.58v37.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m508.74,287.37h-107.42v37.27h107.42v-37.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m508.74,459.66h-61.29v3.81h61.29v-3.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m531.35,459.66h-22.61v3.81h22.61v-3.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m508.74,324.64h-107.42v3.81h107.42v-3.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m574.32,324.64h-65.58v3.81h65.58v-3.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m431.87,328.44h-19.61v3.2h19.61v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m416.11,350.02c-.96-3.6-4.67-5.74-8.27-4.77l-23.8,6.37.24.92,5.25,1.07,2.63,9.81,19.18-5.14c3.61-.96,5.73-4.67,4.77-8.27Zm-2.82.55c0-.42.34-.76.76-.76s.76.34.76.76-.34.76-.76.76-.76-.34-.76-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m412.26,334.38c0,.8.65,1.44,1.44,1.44h.57c1.91,0,3.46,1.55,3.46,3.46v7.5l-1.87.51c.53.74.94,1.58,1.19,2.49.24.9.3,1.81.22,2.69l2.03-.54c.75.62,1.72,1,2.78,1,2.4,0,4.35-1.95,4.35-4.35v-9.3c0-1.91,1.55-3.46,3.46-3.46h.57c.8,0,1.44-.65,1.44-1.44v-1.77h-19.61v1.77h-.02Zm11.73,14.02c0,1.07-.86,1.93-1.92,1.93s-1.92-.86-1.92-1.93.86-1.92,1.92-1.92,1.92.86,1.92,1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m558.7,328.44h-17.08v3.2h17.08v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m558.69,332.6h-17.08v1.77c0,.8.56,1.43,1.25,1.43h.49c1.66,0,3.01,1.55,3.01,3.46v9.3c0,2.4,1.7,4.35,3.79,4.35.92,0,1.76-.38,2.41-1l1.77.54c-.07-.88-.02-1.79.2-2.69.21-.92.57-1.75,1.03-2.49l-1.63-.51v-7.5c0-1.91,1.35-3.46,3.01-3.46h.49c.69,0,1.25-.65,1.25-1.43v-1.77Zm-8.54,13.86c.92,0,1.68.86,1.68,1.93s-.75,1.92-1.68,1.92-1.68-.86-1.68-1.92.75-1.93,1.68-1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m514.57,732.39h29.01v-66.39h-29.01v66.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m514.57,666.01h-79.78v66.38h79.78v-66.38Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessor);
export default __webpack_public_path__ + "static/media/Lessor.400de0beb39afe05db197c65be09ab6e.svg";
export { ForwardRef as ReactComponent };